import { useState, useEffect } from "react";
import EditPrompt from "./EditPrompt";
import AddPrompt from "./AddPrompt";
import { ImSpinner } from "react-icons/im";
import { MdDelete } from "react-icons/md";
import DeleteAgent from "./DeletePrompt";
import { fetchData } from "../GlobalFunctions";

let currentIdDatabase = 0;

function UserPrompt({ userPermissions }: any) {
  interface PromptData {
    id: string;
    prompt_name: string;
    prompt_text: string;
    type: string;
  }

  const [promptData, setPromptData] = useState<PromptData[] | null>(null);

  const [name, setName] = useState("");

  const [isPromptOpen, setIsPromptOpen] = useState(false);
  const [promptEditOpen, setPromptEditOpen] = useState(false);
  const [openDeleteAll, setOpenDelete] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const openDeleteButton = (id: number) => {
    currentIdDatabase = id;
    setOpenDelete(true);
  };

  const closeDeleteCancelButton = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setOpenDelete(false);
    }
  };

  const closeDeleteButton = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setPromptData(null);
      setOpenDelete(false);
    }
  };

  const openAgent = () => {
    setIsPromptOpen(true);
  };

  const openEditPrompt = (id: number) => {
    setPromptEditOpen(true);
    currentIdDatabase = id;
  };

  const closeEditAgent = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setPromptEditOpen(false);
    }
  };

  const xCloseEditAgent = (e: React.MouseEvent<HTMLDivElement>) => {
    setPromptEditOpen(false);
  };

  const closePrompt = () => {
    setName("");
    setIsPromptOpen(false);
  };

  const handlePromptClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closePrompt();
    }
  };

  useEffect(() => {
    setOpenDelete(false);
    setPromptEditOpen(false);
    fetchData(`${process.env.REACT_APP_USER_PROMPT_LIST}`, setPromptData);
  }, [refresh]);

  //   const isAllowAdd =
  //     userPermissions &&
  //     getPermissionForName(userPermissions, "allow_add", "Data Agents");

  //   const isAllowEdit =
  //     userPermissions &&
  //     getPermissionForName(userPermissions, "allow_edit", "Data Agents");

  //   const isAllowDelete =
  //     userPermissions &&
  //     getPermissionForName(userPermissions, "allow_delete", "Data Agents");

  return (
    <div>
      <div className="flex flex-row gap-3 justify-end mb-3">
        {
          <button
            onClick={openAgent}
            className="bg-[#4D30B5] hover:bg-[#1b1436] text-white py-2 px-4 rounded duration-300 "
          >
            Create Business Rule
          </button>
        }
      </div>
      <div>
        {promptData && promptData.length > 0 ? (
          <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {promptData?.map((data, index) => (
              <div
                role="button"
                onClick={() => openEditPrompt(index)}
                key={index}
                className={`relative flex flex-col gap-4 p-8 m-4 items-center hover:bg-gray-400 rounded-lg duration-300 bg-[#EDEAF8]`}
              >
                {
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openDeleteButton(index);
                    }}
                    className="absolute right-5 bg-[#4D30B5] hover:bg-[#1b1436] text-white p-2 rounded duration-300"
                  >
                    <MdDelete />
                  </button>
                }
                <div className=" flex  items-center">
                  <p className=" text-[25px]">{data.prompt_name}</p>
                </div>
                <div className="max-w-[400px] max-h-[200px] overflow-y-scroll custom-scrollbar-chat">
                  <pre className=" whitespace-break-spaces">
                    <code>{data.prompt_text}</code>
                  </pre>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-center">
            <ImSpinner size={30} className=" animate-spin" />
          </div>
        )}
      </div>
      {isPromptOpen && (
        <AddPrompt
          handlePromptClick={handlePromptClick}
          closePrompt={closePrompt}
          setRefresh={setRefresh}
        />
      )}
      {promptData
        ? openDeleteAll && (
            <DeleteAgent
              closeDeleteButton={closeDeleteButton}
              idEdit={promptData[currentIdDatabase]?.id}
              nameEdit={promptData[currentIdDatabase].prompt_name}
              setRefresh={setRefresh}
              closeDeleteCancelButton={closeDeleteCancelButton}
            />
          )
        : null}
      {promptData
        ? promptEditOpen && (
            <EditPrompt
              xCloseEditAgent={xCloseEditAgent}
              closeEditAgent={closeEditAgent}
              nameEdit={promptData[currentIdDatabase].prompt_name}
              descriptionEdit={promptData[currentIdDatabase].prompt_text}
              idEdit={promptData[currentIdDatabase].id}
              setRefresh={setRefresh}
            />
          )
        : null}
    </div>
  );
}

export default UserPrompt;
